import { render } from "./SectionStudentTopList.vue?vue&type=template&id=767770fa"
import script from "./SectionStudentTopList.vue?vue&type=script&lang=js"
export * from "./SectionStudentTopList.vue?vue&type=script&lang=js"

import "./SectionStudentTopList.vue?vue&type=style&index=0&id=767770fa&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__